import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal", "form", "name"]

  open(event) {
    event.preventDefault()
    const button = event.currentTarget
    this.formTarget.action = button.dataset.duplicateUrl
    this.nameTargets.forEach((element) => {
      element.textContent = button.dataset.eventName
    })
    $(this.modalTarget).modal("show")
  }
}
